import { useEffect } from 'react'
import { alpha, useTheme } from '@mui/material/styles'
import { IconButton, Tooltip } from '@mui/material'
import { IconHelp } from '@tabler/icons-react'
import { hideSmartsuppChat, openSmartsuppChat } from '@utils/smartsupp'
import { useMenuBranding } from './MenuBrandingContext'

const SMARTSUPP_SYSTEM = 'IR Menú Digital'

export function MenuHelpButton() {
    const theme = useTheme()
    const { cartaStatus: status, cartaData: data } = useMenuBranding()

    useEffect(() => {
        const timer = setTimeout(() => {
            hideSmartsuppChat()
        }, 1000)

        return () => clearTimeout(timer)
    }, [])

    const shouldShow =
        status === 'found' &&
        Boolean(data?.pagos_online_activos)

    if (!shouldShow) return null

    return (
        <Tooltip title="Ayuda">
            <IconButton
                aria-label="Ayuda"
                onClick={() => openSmartsuppChat(SMARTSUPP_SYSTEM)}
                sx={{
                    width: 40,
                    height: 40,
                    border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
                    bgcolor: alpha(theme.palette.common.white, 0.04),
                    color: 'text.primary',
                    '&:hover': {
                        bgcolor: alpha(theme.palette.primary.main, 0.08),
                    },
                }}
            >
                <IconHelp size={20} stroke={1.75} />
            </IconButton>
        </Tooltip>
    )
}
